
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useNumericInput from "../../hooks/useNumericInput";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import CartItemsinCheckout from "../canvas/CartItemsinCheckout";
import { useCart } from "../../context/CartContext";
import Breadcrump from "../../components/Breadcrump";
import Summary from "./common/Summary";
import addressAPI from "../../api/addressApi";
import { useCheckout } from "../../hooks/useCheckout";
import { showError, showSuccess } from "../../utils/toastUtils";
import PaymentService from "./gateways/PaymentServices";
import { useSiteConfig } from "../../context/SiteConfigContext";

function Checkout() {
  useNumericInput();
  useAlphabeticInput();
  const { cartItems, fetchCart, cartSummary } = useCart();
  const { config } = useSiteConfig();
  const navigate = useNavigate();

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState("contact");

  const [savedAddresses, setSavedAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState("");

 
  //   {
  //     code: "razorpay",
  //     name: "Pay with Razorpay",
  //   },
  // ];
 // const paymentMethods = [
 
 
 const paymentMethods = [
    {
      code: "cod",
      name: "Cash on Delivery",
    },
    {
      code: "razorpay",
      name: "Pay with Razorpay",
    },
    // {
    //   code: "payu",
    //   name: "Pay with PayU",
    // },
  ];
 const auth = JSON.parse(localStorage.getItem("token") ?? "{}");

  const INITIAL_FORM_DATA = {
    email: auth.email || sessionStorage.getItem("emailId") || "",
    phone: sessionStorage.getItem("phoneNum") || "",
    firstName: "",
    lastName: "",
    address: {
      addressType: "home",
      addressLine1: "",
      addressLine2: "",
      pinCode: "",
      district: "",
      state: "",
      country: "",
    },
    isShippingSameasBilling: false,
    shippingAddress: {},
    paymentMethod: "razorpay",
    gstin: "",
  };

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const { placeOrder } = useCheckout(cartItems, formData);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedAddress("");

    if (name.includes(".")) {
      const [parent, child] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[6-9]\d{9}$/;
  const isContactValid = !!formData.email?.trim() && !!formData.phone?.trim();

  const validate = () => {
    const errors = {};
    if (!formData.email) {
      errors.email = "Please Enter Email Address";
    } else if (!emailRegex.test(formData.email)) {
      errors.email = "Please enter a valid email";
    }

    if (!formData.phone) {
      errors.phone = "Enter Phone Number";
    } else if (!phoneRegex.test(formData.phone)) {
      errors.phone = "Phone must be of 10 digits";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (formData.email && formData.phone) {
      if (!validate()) return;
      getAllMyAddress();
      setActive("address");
    }
  }, []);

  const saveSessionData = () => {
    const { email, phone } = formData;
    email ? sessionStorage.setItem("emailId", email) : sessionStorage.removeItem("emailId");
    phone ? sessionStorage.setItem("phoneNum", phone) : sessionStorage.removeItem("phoneNum");
  };

  const handleContinue = (e) => {
    e.preventDefault();
    saveSessionData();
    if (!validate()) return;
    setActive("address");
    getAllMyAddress();
  };

  const getAllMyAddress = async () => {
    try {
      const res = await addressAPI.fetchAllAddress({ email: formData.email });
      if (res.code === 200) {
        setSavedAddresses(res.data);
        setFormData((prev) => ({
          ...prev,
          firstName: res.data.firstName || "",
          lastName: res.data.lastName || "",
        }));
      }
    } catch (err) {}
  };

  const handleSavedAddressSelect = (address) => {
    setSelectedAddress(address._id);
    setFormData((prev) => ({
      ...prev,
      firstName: address.firstName || "",
      lastName: address.lastName || "",
      address: {
        addressType: address.addressType || "home",
        addressLine1: address.addressLine1 || "",
        addressLine2: address.addressLine2 || "",
        pinCode: address.pinCode || "",
        district: address.district || "",
        state: address.state || "",
        country: address.country || "",
      },
    }));
  };

  useEffect(() => {
    if (formData.address?.pinCode?.length === 6) {
      fetchPincodeDetails(formData.address?.pinCode);
    }
  }, [formData.address?.pinCode]);

  const fetchPincodeDetails = async (pincode) => {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
      const data = await res.json();
      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];
        setFormData((prev) => ({
          ...prev,
          address: {
            ...prev.address,
            state: postOffice.State,
            district: postOffice.District,
            country: postOffice.Country,
          },
        }));
      }
    } catch (error) {
      console.error("Error fetching pincode:", error);
    }
  };

  const addressvalidate = () => {
    const requiredFields = [
      "firstName",
      "addressType",
      "addressLine1",
      "pinCode",
      "district",
      "state",
      "country",
    ];
    const errors = {};
    requiredFields.forEach((field) => {
      if (field === "firstName") {
        if (!formData.firstName) errors[field] = `Please Enter ${field}`;
      } else {
        if (!formData.address[field]) errors[field] = `Please Enter ${field}`;
      }
    });
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePlaceOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!addressvalidate()) {
        setLoading(false);
        return;
      }
      const action = await placeOrder();
      if (!action) throw new Error("Something went wrong");

      if (action.type === "COD_SUCCESS") {
        const { orderId } = action.payload;
        showSuccess(action.message);
        sessionStorage.setItem("orderId", orderId);
        sessionStorage.removeItem("emailId");
        sessionStorage.removeItem("phoneNum");
        navigate("/order-confirmation");
      }

      if (action.type === "PAYMENT_STARTED") {
        const { orderId, paymentMethod, gatewayOrderId, amount, currency } = action.payload;
        PaymentService.pay(paymentMethod.toLowerCase(), {
          gatewayOrderId,
          orderId,
          amount,
          currency,
          formData,
          navigate,
          config,
          fetchCart,
        });
      }
    } catch (err) {
      console.error(err);
      showError(err.message || "Order failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate-fade-in transition-all duration-300" style={{ fontFamily: "var(--font-body)" }}>
      <Breadcrump title="Checkout" />

      <div className="py-6 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          
          {/* Left Column: Forms and Accordions */}
          <div className="lg:col-span-8 space-y-4">
            
            {/* Accordion 1: Contact Details */}
            <div className="bg-white border rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md" style={{ borderColor: "var(--card-border)" }}>
              <div
                className={`flex items-center justify-between p-4 cursor-pointer font-medium transition-all duration-300 ${
                  active !== "contact" ? "opacity-75 bg-gray-50 text-gray-800" : "text-white"
                }`}
                style={active === "contact" ? { backgroundColor: "var(--color-primary)", color: "var(--color-text-inverse)" } : {}}
                onClick={() => {
                  if (active === "address" && !isContactValid) return;
                  setActive("contact");
                }}
              >
                <span className="flex items-center flex-wrap gap-2 text-sm sm:text-base font-semibold" style={{ fontFamily: "var(--font-heading)" }}>
                  Share your Contact Details
                  {active !== "contact" && isContactValid && (
                    <span className="text-xs px-2.5 py-0.5 rounded-full font-normal" style={{ backgroundColor: "var(--color-primary-lighter)", color: "var(--color-primary-dark)" }}>
                      ({formData.email}, {formData.phone})
                    </span>
                  )}
                </span>
                <span className={`transform transition-transform duration-300 ${active === "contact" ? "rotate-180" : ""}`}>
                  ↓
                </span>
              </div>

              {active === "contact" && (
                <div className="p-4 sm:p-5 border-t border-gray-100 animate-slide-down" style={{ backgroundColor: "var(--bg-light-panel)" }}>
                  <form onSubmit={handleContinue}>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
                      
                      {/* Email Field */}
                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="email"
                          name="email"
                          placeholder=" "
                          value={formData.email}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 z-10 origin-[0] left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          Email Address
                        </label>
                        {errors?.email && (
                          <span className="text-red-500 text-xs mt-1">{errors.email}</span>
                        )}
                      </div>

                      {/* Phone Field */}
                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="text"
                          name="phone"
                          placeholder=" "
                          value={formData.phone}
                          maxLength={10}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 z-10 origin-[0] left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          Phone Number
                        </label>
                        {errors?.phone && (
                          <span className="text-red-500 text-xs mt-1">{errors.phone}</span>
                        )}
                      </div>

                      {/* Continue Button */}
                      <button 
                        type="submit"
                        className="font-medium py-2.5 px-3 rounded-lg shadow transition duration-200 text-xs uppercase tracking-wider text-white h-[42px]"
                        style={{ backgroundColor: "var(--color-primary)" }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = "var(--color-primary-dark)"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = "var(--color-primary)"}
                      >
                        CONTINUE
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>

            {/* Accordion 2: Address Details */}
            <div className="bg-white border rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md" style={{ borderColor: "var(--card-border)" }}>
              <div
                className={`flex items-center justify-between p-4 cursor-pointer font-medium transition-all duration-300 ${
                  active !== "address" ? "opacity-75 bg-gray-50 text-gray-800" : "text-white"
                }`}
                style={active === "address" ? { backgroundColor: "var(--color-primary)", color: "var(--color-text-inverse)" } : {}}
                onClick={() => {
                  if (!isContactValid) return;
                  setActive("address");
                }}
              >
                <span className="text-sm sm:text-base font-semibold" style={{ fontFamily: "var(--font-heading)" }}>Enter your Address</span>
                <span className={`transform transition-transform duration-300 ${active === "address" ? "rotate-180" : ""}`}>
                  ↓
                </span>
              </div>

              {active === "address" && (
                <div className="p-4 sm:p-5 border-t border-gray-100 space-y-4 animate-slide-down" style={{ backgroundColor: "var(--bg-light-panel)" }}>
                  
                  {savedAddresses.length > 0 && (
                    <div>
                      <b className="text-xs sm:text-sm block mb-2" style={{ color: "var(--color-text-primary)" }}>Select a saved address:</b>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {savedAddresses.map((address) => (
                          <div
                            key={address._id}
                            onClick={() => handleSavedAddressSelect(address)}
                            className={`p-3 border rounded-xl cursor-pointer transition-all duration-200 ${
                              selectedAddress === address._id ? "shadow-sm" : "hover:border-gray-300 bg-white"
                            }`}
                            style={{
                              borderColor: selectedAddress === address._id ? "var(--color-primary)" : "var(--card-border)",
                              backgroundColor: selectedAddress === address._id ? "var(--bg-secondary)" : "#ffffff"
                            }}
                          >
                            <label className="flex items-start space-x-2.5 cursor-pointer">
                              <input
                                type="radio"
                                className="mt-0.5"
                                style={{ accentColor: "var(--color-primary)" }}
                                name="savedAddress"
                                checked={selectedAddress === address._id}
                                onChange={() => handleSavedAddressSelect(address)}
                              />
                              <span className="text-xs leading-relaxed" style={{ color: "var(--color-text-secondary)" }}>
                                <strong className="uppercase text-xs tracking-wider block mb-0.5" style={{ color: "var(--color-text-primary)" }}>
                                  {address.addressType}
                                </strong>
                                {address.firstName} {address.lastName}
                                <br />
                                {address.addressLine1}, {address.addressLine2}, {address.district}, {address.state} - {address.pinCode}
                                <br />
                                {address.country}
                              </span>
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Address Form Inputs */}
                  <div className="space-y-3 pt-1">
                    <div className="text-sm sm:text-base font-medium" style={{ color: "var(--color-text-primary)", fontFamily: "var(--font-heading)" }}>Address Details</div>
                    
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      {/* First Name */}
                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="text"
                          name="firstName"
                          placeholder=" "
                          value={formData.firstName}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          First name <span className="text-red-500">*</span>
                        </label>
                        {errors?.firstName && (
                          <span className="text-red-500 text-xs mt-1">{errors.firstName}</span>
                        )}
                      </div>

                      {/* Last Name */}
                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="text"
                          name="lastName"
                          placeholder=" "
                          value={formData.lastName}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          Last name
                        </label>
                      </div>
                    </div>

                    {/* Address Type Selection */}
                    <div>
                      <label className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{ color: "var(--color-text-secondary)" }}>
                        Address Type <span className="text-red-500">*</span>
                      </label>
                      <div className="grid grid-cols-3 gap-2">
                        {["home", "work", "other"].map((type) => (
                          <label
                            key={type}
                            className={`flex items-center justify-center p-2 border rounded-lg cursor-pointer transition-all ${
                              formData.address.addressType === type ? "font-medium shadow-xs" : "hover:bg-gray-50"
                            }`}
                            style={{
                              borderColor: formData.address.addressType === type ? "var(--color-primary)" : "var(--card-border)",
                              backgroundColor: formData.address.addressType === type ? "var(--bg-secondary)" : "#ffffff",
                              color: formData.address.addressType === type ? "var(--color-primary)" : "var(--color-text-secondary)"
                            }}
                          >
                            <input
                              type="radio"
                              className="hidden"
                              value={type}
                              name="address.addressType"
                              checked={formData.address.addressType === type}
                              onChange={handleChange}
                            />
                            <span className="text-xs uppercase tracking-wider">{type}</span>
                          </label>
                        ))}
                      </div>
                      {errors?.addressType && (
                        <span className="text-red-500 text-xs mt-1 block">{errors.addressType}</span>
                      )}
                    </div>

                    {/* Address Line 1 */}
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="address.addressLine1"
                        placeholder=" "
                        value={formData.address.addressLine1}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        Address <span className="text-red-500">*</span>
                      </label>
                      {errors?.addressLine1 && (
                        <span className="text-red-500 text-xs mt-1">{errors.addressLine1}</span>
                      )}
                    </div>

                    {/* Address Line 2 */}
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="address.addressLine2"
                        placeholder=" "
                        value={formData.address.addressLine2}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        Apartment, suite, etc (optional)
                      </label>
                    </div>

                    {/* Pincode, District, State */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          maxLength={6}
                          type="text"
                          name="address.pinCode"
                          placeholder=" "
                          value={formData.address.pinCode}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          Zipcode/Postal <span className="text-red-500">*</span>
                        </label>
                        {errors?.pinCode && (
                          <span className="text-red-500 text-xs mt-1">{errors.pinCode}</span>
                        )}
                      </div>

                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="text"
                          name="address.district"
                          placeholder=" "
                          value={formData.address.district}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          District <span className="text-red-500">*</span>
                        </label>
                        {errors?.district && (
                          <span className="text-red-500 text-xs mt-1">{errors.district}</span>
                        )}
                      </div>

                      <div className="relative flex flex-col">
                        <input
                          className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                          style={{ borderColor: "var(--card-border)" }}
                          type="text"
                          name="address.state"
                          placeholder=" "
                          value={formData.address.state}
                          onChange={handleChange}
                        />
                        <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                          State <span className="text-red-500">*</span>
                        </label>
                        {errors?.state && (
                          <span className="text-red-500 text-xs mt-1">{errors.state}</span>
                        )}
                      </div>
                    </div>

                    {/* Country */}
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="address.country"
                        placeholder=" "
                        value={formData.address.country}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        Country <span className="text-red-500">*</span>
                      </label>
                      {errors?.country && (
                        <span className="text-red-500 text-xs mt-1">{errors.country}</span>
                      )}
                    </div>

                    {/* Same Shipping as Billing Checkbox */}
                    <div className="pt-2">
                      <label className="flex items-center gap-2 cursor-pointer select-none">
                        <input
                          type="checkbox"
                          className="w-4 h-4 rounded border-gray-300 cursor-pointer"
                          style={{ accentColor: "var(--color-primary)" }}
                          checked={formData.isShippingSameasBilling}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            if (checked) {
                              setFormData((prev) => ({
                                ...prev,
                                isShippingSameasBilling: true,
                                shippingAddress: {
                                  ...prev.address,
                                  firstName: prev.firstName,
                                  lastName: prev.lastName,
                                  mobileNumber: prev.phone,
                                },
                              }));
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                isShippingSameasBilling: false,
                                shippingAddress: {},
                              }));
                            }
                          }}
                        />
                        <span className="text-xs sm:text-sm font-medium" style={{ color: "var(--color-text-primary)" }}>
                          Is your shipping address same as billing address?
                        </span>
                      </label>
                    </div>

                    {/* GSTIN Field */}
                    <div className="relative flex flex-col pt-1">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white uppercase"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="gstin"
                        placeholder=" "
                        maxLength={15}
                        value={formData.gstin || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        GST Number <span className="text-gray-400 font-normal">(optional)</span>
                      </label>
                    </div>

                    {/* Continue Button */}
                    <div className="pt-2">
                      <button
                        type="button"
                        className="font-medium py-2.5 px-6 rounded-lg shadow transition duration-200 text-xs uppercase tracking-wider text-white"
                        style={{ backgroundColor: "var(--color-primary)" }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = "var(--color-primary-dark)"}
                        onMouseLeave={(e) => e.target.style.backgroundColor = "var(--color-primary)"}
                        onClick={() => {
                          if (!addressvalidate()) return;
                          setActive("shipping");
                        }}
                      >
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Accordion 3: Shipping Details */}
            <div className="bg-white border rounded-xl shadow-sm overflow-hidden transition-all duration-300 hover:shadow-md" style={{ borderColor: "var(--card-border)" }}>
              <div
                className={`flex items-center justify-between p-4 cursor-pointer font-medium transition-all duration-300 ${
                  active !== "shipping" ? "opacity-75 bg-gray-50 text-gray-800" : "text-white"
                }`}
                style={active === "shipping" ? { backgroundColor: "var(--color-primary)", color: "var(--color-text-inverse)" } : {}}
                onClick={() => {
                  if (active !== "shipping" && !addressvalidate()) return;
                  setActive("shipping");
                }}
              >
                <span className="text-sm sm:text-base font-semibold" style={{ fontFamily: "var(--font-heading)" }}>Shipping Details</span>
                <span className={`transform transition-transform duration-300 ${active === "shipping" ? "rotate-180" : ""}`}>
                  ↓
                </span>
              </div>

              {active === "shipping" && (
                <div className="p-4 sm:p-5 border-t border-gray-100 space-y-3 animate-slide-down" style={{ backgroundColor: "var(--bg-light-panel)" }}>
                  <div className="text-sm sm:text-base font-medium" style={{ color: "var(--color-text-primary)", fontFamily: "var(--font-heading)" }}>
                    Shipping Details
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {/* Shipping First Name */}
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="shippingAddress.firstName"
                        placeholder=" "
                        value={formData.shippingAddress?.firstName || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        First name <span className="text-red-500">*</span>
                      </label>
                    </div>

                    {/* Shipping Last Name */}
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="shippingAddress.lastName"
                        placeholder=" "
                        value={formData.shippingAddress?.lastName || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        Last name
                      </label>
                    </div>
                  </div>

                  {/* Shipping Phone Number */}
                  <div className="relative flex flex-col">
                    <input
                      className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                      style={{ borderColor: "var(--card-border)" }}
                      type="text"
                      name="shippingAddress.mobileNumber"
                      maxLength={10}
                      placeholder=" "
                      value={formData.shippingAddress?.mobileNumber || ""}
                      onChange={handleChange}
                    />
                    <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                  </div>

                  {/* Shipping Address Type */}
                  <div>
                    <label className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{ color: "var(--color-text-secondary)" }}>
                      Address Type <span className="text-red-500">*</span>
                    </label>
                    <div className="grid grid-cols-3 gap-2">
                      {["home", "work", "other"].map((type) => (
                        <label
                          key={type}
                          className={`flex items-center justify-center p-2 border rounded-lg cursor-pointer transition-all ${
                            formData.shippingAddress?.addressType === type ? "font-medium shadow-xs" : "hover:bg-gray-50"
                          }`}
                          style={{
                            borderColor: formData.shippingAddress?.addressType === type ? "var(--color-primary)" : "var(--card-border)",
                            backgroundColor: formData.shippingAddress?.addressType === type ? "var(--bg-secondary)" : "#ffffff",
                            color: formData.shippingAddress?.addressType === type ? "var(--color-primary)" : "var(--color-text-secondary)"
                          }}
                        >
                          <input
                            type="radio"
                            className="hidden"
                            value={type}
                            name="shippingAddress.addressType"
                            checked={formData.shippingAddress?.addressType === type}
                            onChange={handleChange}
                          />
                          <span className="text-xs uppercase tracking-wider">{type}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Shipping Address Line 1 */}
                  <div className="relative flex flex-col">
                    <input
                      className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                      style={{ borderColor: "var(--card-border)" }}
                      type="text"
                      name="shippingAddress.addressLine1"
                      placeholder=" "
                      value={formData.shippingAddress?.addressLine1 || ""}
                      onChange={handleChange}
                    />
                    <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                      Address <span className="text-red-500">*</span>
                    </label>
                  </div>

                  {/* Shipping Address Line 2 */}
                  <div className="relative flex flex-col">
                    <input
                      className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                      style={{ borderColor: "var(--card-border)" }}
                      type="text"
                      name="shippingAddress.addressLine2"
                      placeholder=" "
                      value={formData.shippingAddress?.addressLine2 || ""}
                      onChange={handleChange}
                    />
                    <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                      Apartment, suite, etc (optional)
                    </label>
                  </div>

                  {/* Shipping Pincode, District, State */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        maxLength={6}
                        type="text"
                        name="shippingAddress.pinCode"
                        placeholder=" "
                        value={formData.shippingAddress?.pinCode || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        Zipcode/Postal <span className="text-red-500">*</span>
                      </label>
                    </div>

                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="shippingAddress.district"
                        placeholder=" "
                        value={formData.shippingAddress?.district || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        District <span className="text-red-500">*</span>
                      </label>
                    </div>

                    <div className="relative flex flex-col">
                      <input
                        className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                        style={{ borderColor: "var(--card-border)" }}
                        type="text"
                        name="shippingAddress.state"
                        placeholder=" "
                        value={formData.shippingAddress?.state || ""}
                        onChange={handleChange}
                      />
                      <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                        State <span className="text-red-500">*</span>
                      </label>
                    </div>
                  </div>

                  {/* Shipping Country */}
                  <div className="relative flex flex-col">
                    <input
                      className="peer px-3 pt-4 pb-1.5 w-full border rounded-lg focus:outline-none focus:ring-2 text-sm bg-white"
                      style={{ borderColor: "var(--card-border)" }}
                      type="text"
                      name="shippingAddress.country"
                      placeholder=" "
                      value={formData.shippingAddress?.country || ""}
                      onChange={handleChange}
                    />
                    <label className="absolute text-xs duration-300 transform -translate-y-2.5 scale-75 top-3.5 left-3 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-2.5" style={{ color: "var(--color-text-secondary)" }}>
                      Country <span className="text-red-500">*</span>
                    </label>
                  </div>
                </div>
              )}
            </div>

          </div>

          {/* Right Column: Cart Summary & Place Order */}
          <div className="lg:col-span-4">
            <div className="bg-white border rounded-xl p-4 sm:p-5 shadow-sm sticky top-6 space-y-4" style={{ borderColor: "var(--card-border)" }}>
              
              <div className="text-base sm:text-lg font-semibold border-b pb-3" style={{ color: "var(--color-text-primary)", borderColor: "var(--card-border)", fontFamily: "var(--font-heading)" }}>
                In your cart
              </div>

              {cartItems && cartItems.length > 0 && (
                <ul className="divide-y divide-gray-100 max-h-60 overflow-y-auto pr-1">
                  {cartItems.map((item) => (
                    <CartItemsinCheckout item={item} key={item._id} />
                  ))}
                </ul>
              )}

              <Summary cartItems={cartItems} cartSummary={cartSummary} />

              <hr style={{ borderColor: "var(--card-border)" }} />

              <div className="text-base sm:text-lg font-semibold" style={{ color: "var(--color-text-primary)", fontFamily: "var(--font-heading)" }}>
                Payment Method
              </div>

              <div className="space-y-2">
                {paymentMethods.map((method) => ( 
                  <div
                    key={method.code}
                    className="flex items-center p-2.5 border rounded-lg hover:border-gray-300 cursor-pointer bg-white"
                    style={{ borderColor: "var(--card-border)" }}
                  >
                    <label className="flex items-center space-x-2.5 cursor-pointer w-full">
                      <input
                        type="radio"
                        name="paymentMethod"
                        style={{ accentColor: "var(--color-primary)" }}
                        id={method.code}
                        value={method.code}
                        checked={formData.paymentMethod === method.code}
                        onChange={handleChange}
                      />
                      <span className="text-xs sm:text-sm font-medium" style={{ color: "var(--color-text-primary)" }}>{method.name}</span>
                    </label>
                  </div>
                ))}
              </div>

              <div>
                <button
                  className="w-full text-white font-medium py-3 px-4 rounded-xl shadow-md transition duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 text-sm"
                  style={{ backgroundColor: "var(--color-primary)" }}
                  onMouseEnter={(e) => { if (!loading) e.target.style.backgroundColor = "var(--color-primary-dark)"; }}
                  onMouseLeave={(e) => { if (!loading) e.target.style.backgroundColor = "var(--color-primary)"; }}
                  onClick={handlePlaceOrder}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white" />
                      <span>Processing...</span>
                    </>
                  ) : (
                    <span>Place Order</span>
                  )}
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Checkout;